import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/layouts/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/products/product-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.0.0_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.0.0_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/public/assets/images/footer/baby.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/public/assets/images/footer/end.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/public/assets/images/footer/logo.png");
